import Vue from "vue";
import VueRouter, { Route, RouteConfig } from "vue-router";
import RegisterComponent from "../views/Auth/Register.vue";
import ErrorPage from "../views/Homepage/404ErrorPage.vue";

import { Position } from "vue-router/types/router";
import store from "../store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: () => import("../views/Layout/MainLayout.vue"),
    children: [
      {
        path: "/",
        component: () => import("../views/Homepage/HomePage.vue"),
      },
      {
        path: "/terms-of-service",
        component: () => import("../views/Homepage/termsOfService.vue"),
      },
      {
        path: "/Testimonial",
        component: () => import("../views/Testimonial/Testimonial.vue"),
      },
      {
        path: "/notifications",
        component: () => import("../views/Notification/UserNotifications.vue"),
      },
      // {
      //   path: "/404ErrorPage",
      //   component: () => import("../views/Homepage/404ErrorPage.vue"),
      // },
      {
        path: "/termsandconditions",
        component: () => import("../views/Legals/Termsandconditions.vue"),
      },
      {
        path: "/privacypolicy",
        component: () => import("../views/Legals/Privacypolicy.vue"),
      },
      {
        path: "/ethics",
        component: () => import("../views/Legals/ethics.vue"),
      },

      {
        path: "/company",
        component: () => import("../views/Company/company.vue"),
      },
      {
        path: "/Downloads",
        component: () => import("../views/Downloads/Downloads.vue"),
      },

      {
        path: "/membership",
        component: () => import("../views/MemberShip/membership.vue"),
      },
      {
        path: "/blog",
        component: () => import("../views/Blog/Blog.vue"),
      },
      {
        path: "/article/:id",
        component: () => import("../views/Blog/Artical.vue"),
      },
      {
        path: "/video",
        component: () => import("../views/Video/video.vue"),
      },
      {
        path: "/breakthroughpractitioners",
        component: () => import("../views/Breakthrough/breakthrough.vue"),
      },

      {
        path: "/profile",
        component: () => import("../views/Profile/Profile.vue"),
        redirect: "/profile/membershipoverview",
        children: [
          {
            path: "/profile/membershipoverview",
            component: () =>
              import(
                "../components/Profile/MembershipOverviewTab.component.vue"
              ),
          },
          {
            path: "/profile/newsletter",
            component: () =>
              import("../components/Profile/NewsleterTab.component.vue"),
          },
          {
            path: "/profile/membership",
            component: () =>
              import("../components/Profile/MembershipTab.component.vue"),
          },
          {
            path: "/profile/purchases",
            component: () =>
              import("../components/Profile/PurchaseTab.component.vue"),
          },
          {
            path: "/profile/coordinating",
            component: () =>
              import("../components/Profile/coordinatingtab.component.vue"),
          },
          {
            path: "/profile/notifications",
            component: () =>
              import("../components/Profile/NotificationTab.component.vue"),
          },
          {
            path: "/profile/account",
            component: () =>
              import("../components/Profile/AccountTab.component.vue"),
          },
          {
            path: "/profile/instructor",
            component: () =>
              import("../components/Profile/InstructorTab.component.vue"),
          },
          {
            path: "/profile/credentials",
            component: () =>
              import("../components/Profile/CredentialsTab.component.vue"),
          },
          {
            path: "/profile/bio",
            component: () =>
              import("../components/Profile//BioTab.component.vue"),
          },
        ],
      },
      // {
      //   path: "/check",
      //   component: () => import("../views/Profile/check.vue"),
      // },
      {
        path: "/seminars",
        component: () => import("../views/Seminar/seminar.vue"),
      },
      {
        path: "/coordinators",
        component: () => import("../views/coordinators/coordinators.vue"),
      },
      {
        path: "/coordinatorarchived",
        component: () =>
          import("../views/coordinators/coordinatorearchived.vue"),
      },
      {
        path: "/coordinatorconfirmation",
        component: () => import("../views/coordinators/coordinatorconfirm.vue"),
      },
      {
        path: "/location",
        component: () => import("../views/Location/location.vue"),
      },
      {
        path: "/location/locationarchived",
        component: () => import("../views/Location/ArchivedLocation.vue"),
      },
      {
        path: "/students/:id",
        component: () => import("../views/Students/students.vue"),
      },
      {
        path: "/mymanuals",
        component: () => import("../views/mymanuals/mymanuals.vue"),
      },
      {
        path: "/myselfstudy",
        component: () => import("../views/myselfstudy/myselfstudy.vue"),
      },
      {
        path: "/myselfstudy/subjectcourses",
        component: () => import("../views/myselfstudy/subjectcourses.vue"),
      },
      {
        path: "/announcement",
        component: () => import("../views/Announcement/Announcement.vue"),
      },
      {
        path: "/newannouncement/:id",
        component: () => import("../views/Announcement/newannouncement.vue"),
      },
      {
        path: "/purchasedetail",
        component: () => import("../views/Profile/PurchaseDetail.vue"),
      },
      {
        path: "/coursesdetail",
        component: () => import("../views/Profile/CoursesDetail.vue"),
      },
      {
        path: "/myceus",
        component: () =>
          import("../views/Profile/MembershipOverviewCardDetail.vue"),
      },
      {
        path: "/profile/courses",
        component: () => import("../views/Profile/courses.vue"),
      },
      {
        path: "/profile/profilestudents/:id",
        component: () => import("../views/Profile/profileStudents.vue"),
      },
      {
        path: "/profile/orderpurchases",
        component: () => import("../views/Profile/purchases.vue"),
      },

      {
        path: "/forum",
        component: () => import("../views/Forum/Forum.vue"),
      },
      {
        path: "/howforum",
        component: () => import("../views/Forum/How_Forum.vue"),
      },
      {
        path: "/hardshipapplication",
        component: () => import("../views/Hardshipapplication/hardshipapp.vue"),
      },
      {
        path: "/forum/postdetail/:id",
        component: () => import("../views/Forum/PostDetailView.vue"),
      },

      {
        path: "/studygroupsandevents",
        component: () =>
          import("../views/StudyGroupAndEvent/StudyGroupAndEvent.vue"),
      },
      {
        path: "/takesurvey",
        component: () => import("../views/Takesurvey/takesurvey.vue"),
      },
      {
        path: "/mailing",
        component: () => import("../views/Mailing/Mailing.vue"),
      },

      // {
      //   path: "/foundation/home",
      //   component: () => import("../views/Foundation/Homepage.vue"),
      // },
      // {
      //   path: "/foundation/journal",
      //   component: () => import("../views/Foundation/Journal.vue"),
      // },
      // {
      //   path: "/foundation/aboutibf",
      //   component: () => import("../views/Foundation/About.vue"),
      // },
      // {
      //   path: "/foundation/media",
      //   component: () => import("../views/Foundation/Media.vue"),
      // },
      // {
      //   path: "/practitioner",
      //   component: () => import("../views/Practitioners/Practitioners.vue"),
      // },
      {
        path: "/practitioner/practitionerdetail/:id",
        component: () =>
          import("../views/Practitioners/PractitionerDetail.vue"),
      },
      {
        path: "/becomepractitioner",
        component: () =>
          import("../views/BecomePractitioner/BecomePractitioner.vue"),
      },
      // {
      //   path: "/becomeinstructor",
      //   component: () =>
      //     import("../views/BecomePractitioner/BecomePractitioner.vue"),
      // },
      {
        path: "/becomepractitioner/CBP",
        component: () =>
          import("../views/BecomePractitioner/ViewBecomePractitionerCBP.vue"),
      },
      {
        path: "/becomepractitioner/AdvCBP",
        component: () =>
          import("../views/BecomePractitioner/ViewBecomePractitionerADV.vue"),
      },
      {
        path: "/becomepractitioner/CBPA",
        component: () =>
          import("../views/BecomePractitioner/ViewBecomePractitionerCBPA.vue"),
      },
      {
        path: "/bodytalkpractitioners",
        component: () => import("../views/Practitioners/Practitioners.vue"),
      },
      {
        path: "/animalpractitioner",
        component: () => import("../views/Practitioners/Practitioners.vue"),
      },
      {
        path: "/advancedpractitioner",
        component: () => import("../views/Practitioners/Practitioners.vue"),
      },
      {
        path: "/paramapractitioner",
        component: () => import("../views/Practitioners/Practitioners.vue"),
      },
      {
        path: "/instructor",
        component: () => import("../views/Practitioners/Practitioners.vue"),
      },
      {
        path: "/profile/newsletter",
        component: () => import("../views/Profile/NewsLetterView.vue"),
      },

      {
        path: "/profile/ibacoordinator",
        component: () =>
          import("../views/Profile/Iba_coordinator_agreement.vue"),
      },
      {
        path: "/profile/CBPagreement",
        component: () =>
          import("../views/Profile/CBPagreement.vue"),
      },
      
      {
        path: "/profile/licensingdetails",
        component: () => import("../views/Profile/LicensingDetails.vue"),
      },
      {
        path: "/profile/viewinvitation",
        component: () => import("../views/Profile/invitecoordinator.vue"),
      },
      {
        path: "/store",
        component: () => import("../views/Storeview/Storeview.vue"),
      },
      {
        path: "/redirectpage",
        component: () => import("../views/RedirectPage/RedirectPage.vue"),
      },
      {
        path: "/store/storedetails/:id",
        component: () => import("../views/Storeview/Storedetails.vue"),
      },
      {
        path: "/store/storeerror",
        component: () => import("../views/Storeview/storeerror.vue"),
      },
      {
        path: "/store/cart",
        component: () => import("../views/Storeview/seecart.vue"),
      },
      {
        path: "/instructorcheckout",
        component: () =>
          import("../components/InstructorTraining/InstructorCheckoutComponent.vue"),
      },

      {
        path: "/courses",
        component: () => import("../views/Courses/Courses.vue"),
      },

      {
        path: "/beginnercourses",
        component: () => import("../views/Courses/CoursesForBeginners.vue"),
      },
      {
        path: "/selfstudy",
        component: () => import("../views/Courses/ParamaCourses.vue"),
      },
      {
        path: "courselibrary",
        component: () => import("../views/Courses/LiveCourses.vue"),
      },
      {
        path: "/courses/detail/:id",
        component: () => import("../views/Courses/DetailsCourses.vue"),
      },
      {
        path: "/courses/:seminarID",
        component: () =>
          import("../components/Courses/AddSeminar.component.vue"),
      },
      {
        path: "/courses/seminarID-IBA",
        component: () =>
          import("../components/Courses/AddSeminarIBA.component.vue"),
      },
      {
        path: "/courses/detailparama",
        component: () => import("../views/Courses/pramacourseDetails.vue"),
      },
      // {
      //   path: "/courses/category/bodytalkforanimals",
      //   component: () => import("../views/Courses/CoursesBodyTalkForAnimalsCategory.vue"),
      // },
      // {
      //   path: "/courses/category/bodytalkfundamentals",
      //   component: () => import("../views/Courses/CoursesBodyTalkCategory.vue"),
      // },
      // {
      //   path: "/courses/category/bodytalkaccess",
      //   component: () => import("../views/Courses/CoursesBodyTalkAccessCategory.vue"),
      // },
      // {
      //   path: "/courses/category/mindscape",
      //   component: () => import("../views/Courses/CoursesMindscapeCategory.vue"),
      // },
      // {
      //   path: "/courses/category/breakthrough",
      //   component: () => import("../views/Courses/CoursesBreakthroughCategory.vue"),
      // },
      // {
      //   path: "/courses/category/paramabodytalk",
      //   component: () => import("../views/Courses/PaRamaBodyTalkCategory.vue"),
      // },
      // {
      //   path: "/courses/category/bodytalkdevelopment",
      //   component: () => import("../views/Courses/BodyTalkdevelopmentCategory.vue"),
      // },
      // {
      //   path: "/courses/category/bodytalkadvancedmodules",
      //   component: () => import("../views/Courses/BodyTalkAdvancedModulesCategory.vue"),
      // },
      // {
      //   path: "/courses/category/specialtycourses",
      //   component: () => import("../views/Courses/SpecialityCoursesCategory.vue"),
      // },
      // {
      //   path: "/courses/category/groupsessions",
      //   component: () => import("../views/Courses/GroupSessionsCategory.vue"),
      // },
      {
        path: "/paramacourses/essentialfounders",
        component: () =>
          import("../views/Courses/Bookscategry/assentailcategory.vue"),
      },
      {
        path: "/paramacourses/studygroups",
        component: () =>
          import("../views/Courses/Bookscategry/studygroupcategory.vue"),
      },
      {
        path: "/paramacourses/specialtycourses",
        component: () =>
          import("../views/Courses/Bookscategry/specialtycategory.vue"),
      },
      {
        path: "/paramacourses/breakthroughcourses",
        component: () =>
          import("../views/Courses/Bookscategry/breakThroughCourses.vue"),
      },
      {
        path: "/paramacourses/groupsessions",
        component: () =>
          import("../views/Courses/Bookscategry/groupsessiondata.vue"),
      },
      // {
      //   path: "/checkout",
      //   component: () => import("../views/Checkout/Checkout.vue"),
      // },
      {
        path: "/membershiprenewal",
        component: () => import("../views/MemberShip/MembershipSetting.vue"),
      },
      {
        path: "/membershipupgrade",
        component: () => import("../views/MemberShip/MembershipUpgrade.vue"),
      },
      {
        path: "/managemembership",
        name: "managemembership",
        component: () => import("../views/MemberShip/managemembership.vue"),
      },
      {
        path: "/manageinstructormembership",
        component: () =>
          import("../views/MemberShip/manageinstructorMember.vue"),
      },
      {
        path: "/membershiprenewalinstructor",
        component: () =>
          import("../views/MemberShip/renewelinstructormembershp.vue"),
      },
      {
        path: "/becomeinstructor",
        component: () =>
          import("../views/InstructorTraining/InstructorTraining.vue"),
      },
      {
        path: "/becomeinstructor/TBAT",
        component: () =>
          import(
            "../views/InstructorTraining/TrainerOfBodyTalkAccessTrainer.vue"
          ),
      },
      {
        path: "/becomeinstructor/BAT",
        component: () =>
          import("../views/InstructorTraining/InstructorTrainingInfo.vue"),
      },
      {
        path: "/becomeinstructor/CBI",
        component: () =>
          import("../views/InstructorTraining/BodytalkFundamentalInfo.vue"),
      },
      {
        path: "/becomeinstructor/AdvCBI",
        component: () =>
          import(
            "../views/InstructorTraining/AdvanceBodyTalkInstructorInfo.vue"
          ),
      },
      {
        path: "/becomeinstructor/BrI",
        component: () =>
          import("../views/InstructorTraining/BreakTroughInstructorInfo.vue"),
      },
      {
        path: "/becomeinstructor/MSI",
        component: () =>
          import("../views/InstructorTraining/MindScapeInstructorInfo.vue"),
      },
      {
        path: "/becomeinstructor/CBI-A",
        component: () =>
          import("../views/InstructorTraining/AnimalInstructorInfo.vue"),
      },
      {
        path: "/becomeinstructor/FFI",
        component: () =>
          import("../views/InstructorTraining/FreeFallInstructorInfo.vue"),
      },
      {
        path: "/modalities",
        component: () => import("../views/Modalities/Modalities.vue"),
      },
      {
        path: "/mindscape",
        component: () => import("../views/Modalities/MindScape.vue"),
      },
      {
        path: "/modalityfreefall",
        component: () => import("../views/Modalities/FreeFall.vue"),
      },
      {
        path: "/bodytalkaccess",
        component: () => import("../views/Modalities/Access.vue"),
      },
      {
        path: "/bodytalkforanimals",
        component: () => import("../views/Modalities/BodyTalkAnimal.vue"),
      },
      {
        path: "/breakthrough",
        component: () => import("../views/Modalities/BreakTrough.vue"),
      },
      {
        path: "/bodytalk",
        component: () => import("../views/Modalities/BodyTalk.vue"),
      },
    ],
  },

  {
    path: "/helpcenterLayout",
    component: () => import("../views/Layout/helpcenterLayout.vue"),
    children: [
      {
        path: "/helpcenter",
        component: () => import("../views/HelpCenter/HelpCenter.vue"),
      },
      {
        path: "/topic",
        component: () => import("../views/HelpCenter/topic.vue"),
      },
    ],
  },
  {
    path: "/BillingLayout",
    component: () => import("../views/Layout/BillingLayout.vue"),
    children: [
      {
        path: "/checkout",
        component: () => import("../views/Billing/billing.vue"),
      },
      {
        path: "/checkout/billingsuccess",
        name: "billingsuccess",
        component: () => import("../views/Billing/billingsuccess.vue"),
      },
      {
        path: "/checkout/billingcross",
        name: "billingcross",
        component: () => import("../views/Billing/billingcross.vue"),
      },
    ],
  },
  {
    path: "/coursecheckout",
    component: () => import("../components/Courses/CourseCheckoutComponent.vue"),
  },
  {
    path: "/manualcheckout",
    component: () => import("../components/Courses/CourseCheckoutComponent.vue"),
  },
  // {
  //   path: "/test",
  //   component: LoaderComponent,
  // },
  {
    path: "/confirmemail/:userId",
    component: () => import("../views/ConfirmEmail/ConfirmEmail.vue"),
    // beforeEnter: (to, from, next) => {
    //   // Example logic before entering the route
    //   localStorage.setItem("userId",to.params.userId);
    //   localStorage.setItem("token",String(to.query.token))
    //   // const userId = to.params.userId;
    //   // const token = to.query.token;
    //   // if (userId && token) {
    //   //   next('/'); // Redirect to home
    //   // }
    // }
  },
  {
    path: "/confirmpaypalpayment",
    component: () => import("../views/PaypalPaymentProcess/ConfirmPaypalPayment.vue"),
  },
  {
    path: "/cancelpaypalpayment",
    component: () => import("../views/PaypalPaymentProcess/CancelPaypalPayment.vue"),
  },
  {
    path: "/registerlayout",
    component: () => import("../views/Layout/AuthLayout.vue"),

    children: [
      {
        path: "/register",
        component: RegisterComponent,
      },
      {
        path: "/forgotpassword",
        component: () => import("../views/Auth/ForgetPassword.vue"),
      },
      {
        path: "/ConfirmPassword",
        component: () => import("../views/Auth/ConfirmPassword.vue"),
      },
    ],
  },
  {
    path: "/donation",
    component: () => import("../views/Donation/Donation.vue"),
  },
  {
    path: "*",
    component: () => import("../views/Layout/MainLayout.vue"),
    redirect: "/error",
    children: [
      {
        path: "/error",
        component: ErrorPage,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  base: '/',
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  
  if (store.getters.AuthenticateUser) {
    next();
  } else {
    next();
  }
});
export default router;
